module.exports = __webpack_public_path__ + "static/media/react-star-wars.207294e9.svg";